import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import {
    AuthController,
    MainPageComponent,
    PaceProgress,
    SideBarComponent,
} from '../adapters/shellAdapters';
import { UserInfoActions } from '../adapters/bootstrapAdapters';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-widgets/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import 'rc-tree/assets/index.css';
import '../assets/css/flag-icons.css';

/**
 * AppShell — Shared top-level application wrapper.
 *
 * Responsibilities:
 *   - Persistent layout structure (sidebar, main area)
 *   - Shared toast/notification host
 *   - Auth controller
 *   - Routed content outlet via <Outlet />
 *
 * This component must NOT contain:
 *   - Page-specific business logic
 *   - Template-local layout forks embedded directly here
 *
 * Shell-level overrides (for example, a template-specific sidebar) should be
 * introduced via a shell override mechanism in the template config, not
 * by branching this file by skin name.
 *
 * Style entry point is intentionally omitted here — each template provides
 * its own style entry via templateConfig.styleEntry (future task).
 */
const AppShell = () => {
    useEffect(() => {
        UserInfoActions.init();
    }, []);

    return (
        <div id="wrapper">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <PaceProgress />
            <AuthController />
            <div className="sidebarContainer">
                <SideBarComponent />
            </div>
            <MainPageComponent>
                <Outlet />
            </MainPageComponent>
        </div>
    );
};

export default AppShell;
